
export class UserModel 
{ 
    UserId : number
    EmailAddr?:string
    FirstName?:string
    LastName?:string
    PhoneNum?:string
    AccountNum?:number
    UserType?:string
    RoleName?:string
    Password:string
    Phone:string 
    Token:string 
    CompanyCode: string   
    LoginId:string 
}

export class RoleDetailList
{

}